<script>

  export default {
    props: {
      isSearchNull: {
        type: Boolean,
        default: false
      },
      content: {
        type: String,
        default: ''
      },
      // imageClass: {
      //   type: String,
      //   default: ''
      // },
      // titleClass: {
      //   type: String,
      //   default: ''
      // }
    },
    data() {
      return {}
    },
    computed: {
      goTo() {
        if(this.to === undefined) {
          return {
            name: 'brand-item'
          }
        }
        return {
          name: 'home'
        }
      }
    },
    methods: {
      onClearSearch() {
        this.$emit('clearSearch')
      }
    }
  }
</script>
<template>

  <div class="bg-gray-2 text-center section text-gray-6 px-3">
    <template v-if="isSearchNull">
      <p class="my-0 text-gray-6">沒有符合搜尋條件</p>
      <BaseButton
        class="isStylePrimary isCol4 isRadius mt-md-5 mt-3"
        @click="onClearSearch"
      >
        清除搜尋結果
      </BaseButton>
    </template>
    <template v-else>
      <div v-html="content"></div>
      <slot/>
    </template>
  </div>
</template>
<style lang="scss" module>

</style>
